import { get } from './ApiService';
import { axiosSubscriptionInstance } from '../configs/AxiosInstance';

// 1. Get Common Utils
export const getCommonUtils = async () => {
  try {
    const data = await get('/get-common-utils', { instance: axiosSubscriptionInstance });
    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.detail || "Failed to fetch common utils. Please try again.",
    };
  }
};

// 2. Get Current Employee
export const getCurrentEmployee = async () => {
  try {
    const data = await get('/get-current-employee', { instance: axiosSubscriptionInstance });
    return { success: true, data };
  } catch (error) {
    // Check if error is "User not found"
    if (error?.response?.data?.detail === "User not found") {
      return { success: false, userNotFound: true, message: "User not found" };
    }
    return {
      success: false,
      userNotFound: false,
      message: error?.response?.data?.detail || "Failed to fetch current employee.",
    };
  }
};
